import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
// import createPersistedState from "vuex-persistedstate";
// import * as Cookies from "js-cookie";

import axios from '../plugins/axios'

import general from './modules/general'

const store = new Vuex.Store({
    modules: {
        general,
    },
    state: {

    },
    mutations: {

    },
    getters: {

    },
    computed: {
    }
});

store.$axios = axios;


export default store;
